import { environment } from "../environments/environment";

/**
 * @deprecated
 */
class Logger {
    /**
     * @deprecated
     */
    get log() {
        return environment.qa === false && environment.production === false
            ? console.log.bind(window.console)
            : // eslint-disable-next-line @typescript-eslint/no-empty-function
              function (...args: unknown[]) {};
    }

    /**
     * @deprecated
     */
    get debug() {
        return environment.qa === false && environment.production === false
            ? console.debug.bind(window.console)
            : // eslint-disable-next-line @typescript-eslint/no-empty-function
              function (...args: unknown[]) {};
    }

    /**
     * @deprecated
     */
    get warn() {
        return environment.qa === false && environment.production === false
            ? console.warn.bind(window.console)
            : // eslint-disable-next-line @typescript-eslint/no-empty-function
              function (...args: unknown[]) {};
    }

    /**
     * @deprecated
     */
    get table() {
        return environment.qa === false && environment.production === false
            ? console.table.bind(window.console)
            : // eslint-disable-next-line @typescript-eslint/no-empty-function
              function (...args: unknown[]) {};
    }

    /**
     * @deprecated
     */
    get trace() {
        return environment.qa === false && environment.production === false
            ? console.trace.bind(window.console)
            : // eslint-disable-next-line @typescript-eslint/no-empty-function
              function (...args: unknown[]) {};
    }

    /**
     * @deprecated
     */
    error(...args: unknown[]) {
        const argumentsString = Array.prototype.slice.call(args);
        argumentsString.unshift(" ");
        // eslint-disable-next-line prefer-spread
        console.error.bind(window.console, argumentsString);
    }
}

/**
 * @deprecated
 */
const logger = new Logger();
export default logger;
